import { statusAndResponse } from "../../../util/requestHandler";
import { Api, decryptApiResponse } from "../../../config/Api";

const getResponse = (r) => r;

export const getColumnList = async (gridName) => {
  return statusAndResponse(
    Api.get(`/api/appsetting/columns/grid/${gridName}`),
    decryptApiResponse,
  );
};

export const getUserColumnConfiguration = async (gridName) => {
  return statusAndResponse(
    Api.get(`/api/appsetting/customizeGrid/user/columns`),
    decryptApiResponse,
  );
};

export const saveUserColumn = async (gridName, columnId) => {
  const route = `/api/appsetting/customizeGrid/user/column`;

  return statusAndResponse(Api.post(route, { columnId }), decryptApiResponse);
};

export const deleteUserColumn = async (gridName, userColumn) => {
  const route = `/api/appsetting/customizeGrid/user/column/${userColumn}`;
  const [status, res] = await statusAndResponse(Api.delete(route), getResponse);
  return status;
};
